import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import NordicMapDashboard from './pages/nordic-map-dashboard';
import TollCalculator from './pages/toll-calculator';
import NordPassSubscriptionPortal from './pages/nord-pass-subscription-portal';
import LoginPage from './pages/login';
import NordPassLandingPage from './pages/nord-pass-landing-page';
import { AuthProvider } from './contexts/AuthContext';
import NordPassContactPage from './pages/nord-pass-contact-page';
import NordPassAdminDashboard from './pages/nord-pass-admin-dashboard';
import OmOssAboutUs from './pages/om-oss-about-us';
import TjenesterServices from './pages/tjenester-services';
import FAQ from './pages/faq';
import AdminRoute from './components/AdminRoute';
import BlogNewsPage from './pages/blog-news-landing-page-blogg-nyheter';
import IndividualArticleDetailView from './pages/individual-article-detail-view';
import PrivacyPolicyPage from './pages/privacy-policy-personvern';
import TermsConditionsPage from './pages/terms-conditions-vilk-r-betingelser';
import SMSOptinVilkarPage from './pages/sms-optin-vilkar';
import SearchResultsPage from './pages/search-results-page';
import AdminCommentModerationDashboard from './pages/admin-comment-moderation-dashboard';
import UserProfileActivityDashboard from './pages/user-profile-activity-dashboard';
import NewsletterSubscriptionThankYouPage from './pages/newsletter-subscription-thank-you-page';
import NewsletterPreferencesManagementPage from './pages/newsletter-preferences-management-page';
import RegisterPage from './pages/register';

const Routes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            <Route path="/" element={<NordPassLandingPage />} />
            <Route path="/nord-pass-landing-page" element={<NordPassLandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/nordic-map-dashboard" element={<NordicMapDashboard />} />
            <Route path="/toll-calculator" element={<TollCalculator />} />
            <Route path="/nord-pass-subscription-portal" element={<NordPassSubscriptionPortal />} />
            <Route path="/nord-pass-contact-page" element={<NordPassContactPage />} />
            <Route
              path="/nord-pass-admin-dashboard"
              element={
                <AdminRoute>
                  <NordPassAdminDashboard />
                </AdminRoute>
              }
            />
            <Route path="/om-oss-about-us" element={<OmOssAboutUs />} />
            <Route path="/tjenester-services" element={<TjenesterServices />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/blog-news-landing-page-blogg-nyheter" element={<BlogNewsPage />} />
            <Route path="/individual-article-detail-view" element={<IndividualArticleDetailView />} />
            <Route path="/privacy-policy-personvern" element={<PrivacyPolicyPage />} />
            <Route path="/terms-conditions-vilk-r-betingelser" element={<TermsConditionsPage />} />
            <Route path="/sms-optin-vilkar" element={<SMSOptinVilkarPage />} />
            <Route path="/search-results-page" element={<SearchResultsPage />} />
            <Route path="/user-profile-activity-dashboard" element={<UserProfileActivityDashboard />} />
            <Route path="/newsletter-subscription-thank-you-page" element={<NewsletterSubscriptionThankYouPage />} />
            <Route path="/newsletter-preferences-management-page" element={<NewsletterPreferencesManagementPage />} />
            <Route
              path="/admin-comment-moderation-dashboard"
              element={
                <AdminRoute>
                  <AdminCommentModerationDashboard />
                </AdminRoute>
              }
            />
            <Route path="*" element={<NotFound />} />
          </RouterRoutes>
        </ErrorBoundary>
      </AuthProvider>
    </BrowserRouter>
  );
};

export default Routes;
